import React from 'react';
import Icon from '../../../components/AppIcon';

const PasswordStrengthIndicator = ({ password }) => {
  const calculateStrength = (pwd) => {
    if (!pwd) return { score: 0, label: '', color: '' };
    
    let score = 0;
    if (pwd?.length >= 8) score++;
    if (pwd?.length >= 12) score++;
    if (/[a-z]/?.test(pwd) && /[A-Z]/?.test(pwd)) score++;
    if (/\d/?.test(pwd)) score++;
    if (/[^a-zA-Z0-9]/?.test(pwd)) score++;

    const levels = [
      { score: 0, label: '', color: '', bgColor: '' },
      { score: 1, label: 'Weak', color: 'text-error', bgColor: 'bg-error' },
      { score: 2, label: 'Fair', color: 'text-warning', bgColor: 'bg-warning' },
      { score: 3, label: 'Good', color: 'text-warning', bgColor: 'bg-warning' },
      { score: 4, label: 'Strong', color: 'text-success', bgColor: 'bg-success' },
      { score: 5, label: 'Very Strong', color: 'text-success', bgColor: 'bg-success' }
    ];

    return levels?.[score];
  };

  const strength = calculateStrength(password);

  const requirements = [
    { met: password?.length >= 8, text: 'At least 8 characters' },
    { met: /[a-z]/?.test(password) && /[A-Z]/?.test(password), text: 'Upper & lowercase letters' },
    { met: /\d/?.test(password), text: 'At least one number' },
    { met: /[^a-zA-Z0-9]/?.test(password), text: 'Special character (!@#$%^&*)' }
  ];

  if (!password) return null;

  return (
    <div className="mt-3 space-y-3">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full transition-smooth ${strength?.bgColor}`}
            style={{ width: `${(strength?.score / 5) * 100}%` }}
          />
        </div>
        <span className={`text-sm font-medium ${strength?.color}`}>
          {strength?.label}
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {requirements?.map((req, index) => (
          <div key={index} className="flex items-center gap-2">
            <Icon
              name={req?.met ? 'CheckCircle2' : 'Circle'}
              size={16}
              color={req?.met ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
            />
            <span className={`text-xs ${req?.met ? 'text-success' : 'text-muted-foreground'}`}>
              {req?.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;